/* Remove a complete box together, keeping its flavor count and pricing consistent. */
(() => {
  if (window.bdjCartBoxReady) return;
  window.bdjCartBoxReady = true;
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-remove-box]');
    if (!button || button.disabled) return;
    const note = button.parentElement.querySelector('[data-remove-box-status]');
    button.disabled = true;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart.js', {cache:'no-store'});
      if (!response.ok) throw Error('Unable to load your cart. Please retry.');
      const cart = await response.json();
      const lines = cart.items.filter(i => i.properties?._box_id === button.dataset.removeBox || (String(i.product_id) === '9675837341923' && i.key === button.dataset.removeBox));
      if (!lines.length) throw Error('Your cart changed. Refresh to review it.');
      const updated = await fetch(root + 'cart/update.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({updates:Object.fromEntries(lines.map(i => [i.key,0]))})});
      if (!updated.ok) throw Error('Unable to remove this box. Please retry.');
      const result = await updated.json();
      if (result.items.some(i => lines.some(line => line.key === i.key))) throw Error('Please refresh and review your cart.');
      try { ['','-size','-purchase','-cart-id'].forEach(suffix => sessionStorage.removeItem('browndog-box-draft'+suffix)); } catch(e) {}
      window.location.reload();
    } catch(error) {
      note.textContent = error.message;
      button.disabled = false;
    }
  });
})();
